import React, { useEffect, useState } from "react";
import {Bell, Settings, User, Search, Menu, LogOut, UserCircle, ChevronDown, ShieldCheck, X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import logo from "../image/Ganesh.png";
import "../Style/Header.css";
import { Client } from "@stomp/stompjs";
import { BASE_URL } from "../Apis/apiConfig";
import SockJS from "sockjs-client";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { FaFilePdf } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import axios from "axios";

const Header = ({ toggleSidebar }) => {
  const [societyName, setSocietyName] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date());
  const [selectedSociety, setSelectedSociety] = useState("");
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [seenNotificationCount, setSeenNotificationCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [societyData, setSocietyData] = useState([])
  const complaintId = location.state?.id;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const storedSocietyName = localStorage.getItem("society");
    if (storedSocietyName) {
      setSocietyName(storedSocietyName);
    }
  }, []);

  useEffect(() => {
    fetchAdmins();
    getSocietyDetails()
  }, []);

  const fetchAdmins = async () => {
    setLoading(true);
    setError("");
    try {
      const email = localStorage.getItem("email");
      const password = localStorage.getItem("password");
      if (!email || !password) {
        throw new Error("Email or password not found in localStorage");
      }
      const params = new URLSearchParams({ email, password });

      const response = await fetch(
        `${BASE_URL}/api/get-all-society-admin?${params.toString()}`,
        {
          method: "POST",
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setAdmins(data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch admins: " + err.message);
    } finally {
      setLoading(false);
    }
  };
  const downloadPdf = () => {
    const link = document.createElement("a");
    link.href = "/admin-crm-user-guide.pdf";
    link.download = "admin-crm-user-guide.pdf";
    link.click();
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    const client = new Client({
      webSocketFactory: () => new SockJS(`${BASE_URL}/ws-chat`),

      connectHeaders: {
        Authorization: `Bearer ${token}`,
      },

      reconnectDelay: 5000,

      onConnect: () => {
        console.log("STOMP connected");

        client.subscribe("/topic/notifications", (message) => {
          const data = JSON.parse(message.body);

          setNotifications((prev) => [data, ...prev]);

          setToastMessage(data.title || data.message);
          setShowToast(true);

          setTimeout(() => setShowToast(false), 3000);
        });
      },

      onStompError: (frame) => {
        console.error("STOMP error:", frame.headers["message"]);
      },
    });

    client.activate();

    return () => client.deactivate();
  }, []);

  const handleNotificationPress = () => {
    setNotificationOpen(!notificationOpen);

    if (!notificationOpen) {
      setSeenNotificationCount(notifications.length);
    }
  };

  const handleAdminLogin = async (societyName) => {
    if (!societyName) {
      setError("Please enter a society name");
      return;
    }
    const adminEmail = localStorage.getItem("email");
    const password = localStorage.getItem("password");
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${BASE_URL}/api/admin-login-multiple`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ societyName, adminEmail, password }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.token) {
        throw new Error("Token not received");
      }

      const decoded = jwtDecode(data.token);
      const role = decoded?.role?.toUpperCase();

      if (role !== "ADMIN") {
        toast.error("You are not authorized to access the admin dashboard.", {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
      localStorage.removeItem("societyRegNo");
      localStorage.removeItem("society");
      localStorage.removeItem("token");

      localStorage.setItem("token", data.token);
      localStorage.setItem("role", role);

      if (decoded.society) {
        localStorage.setItem("society", decoded.society);
      }

      if (decoded.societyRegNo) {
        localStorage.setItem("societyRegNo", decoded.societyRegNo);
      }

      navigate("/dashboard");
      window.location.reload();
    } catch (err) {
      console.error(err);
      toast.error("Please connect to super Admin");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".header-action-item") &&
        !event.target.closest(".header-profile-section")
      ) {
        setNotificationOpen(false);
        setSettingsOpen(false);
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatSocietyName = (name) => {
    if (!name) return "";
    let words = name.split(" ").map((word) => {
      if (word.toLowerCase() === "house") return "LTD";
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return words.join(" ");
  };

  const formatTimeAgo = (timestamp) => {
    if (!timestamp) return "Just now";

    const now = new Date();
    const time = new Date(timestamp);
    const diff = Math.floor((now - time) / 1000); // seconds

    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;

    return time.toLocaleDateString();
  };

  const handleNotificationClick = (n) => {
    if (n.type === "COMPLAINT") {
      navigate("/complaints", { state: { id: n.id } });
    }
    else {
      navigate("/notification");
    }
  };

  const getSocietyDetails = async () => {
    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");
    const regNo = localStorage.getItem("societyRegNo");

    try {
      const response = await axios.post(
        `${BASE_URL}/api1/get-society-details`,
        null,
        {
          params: {
            societyName: societyName,
            SocietyRegistrationNo: regNo,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSocietyData(response.data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <header className="premium-header">
      <div className="header-left-section">
        <button className="mobile-menu-btn d-md-none" onClick={toggleSidebar}>
          <Menu size={24} />
        </button>

        <div className="brand-identity" onClick={() => navigate("/dashboard")}>
          <div className="logo-container">
            {/* <img src={logo} alt="Society Logo" className="society-logo-img" /> */}
            <img
              src={
                societyData?.societyImage && societyData.societyImage.trim() !== ""
                  ? `data:image/jpeg;base64,${societyData.societyImage}`
                  : logo
              }
              alt="Society Logo"
              className="society-logo-img"
            />
          </div>
          <div className="brand-details">
            <h1 className="society-title">
              <span style={{ color: "#007BFF" }}>
                {formatSocietyName(societyName) || "Society Management"}
              </span>
            </h1>
            <span className="brand-subtitle" style={{ color: "blue" }}>
              Admin Portal
            </span>
          </div>
        </div>
      </div>

      <div className="header-right-section">
      
        <div className="society-selector">
          <select
            className="society-select rounded p-1 border-grey text-sm"
            value={selectedSociety}
            onChange={(e) => {
              const society = e.target.value;
              setSelectedSociety(society);
              handleAdminLogin(society);
            }}
            disabled={loading || admins.length === 0}
          >
            <option value="" className="">
              {loading ? "Loading..." : "Switch Society"}
            </option>
            {!loading &&
              admins.length > 0 &&
              admins.map((admin) => (
                <option key={admin.society} value={admin.society}>
                  {admin.society}
                </option>
              ))}
          </select>
            <button className="pdf-btn" onClick={downloadPdf}>
            <FaFilePdf className="pdf-icon" />
          </button>
        </div>
         <div className="time-display flex flex-row gap-1 border py-1 px-3 rounded text-sm bg-blue-600">
          <div className="current-time text-white">
            {formatTime(currentTime)} -
          </div>
          <div className="current-date text-white">
            {formatDate(currentTime)}
          </div>
        </div>
        <div className="header-action-item">
          <button
            className={`action-btn-premium ${notificationOpen ? "active" : ""}`}
            onClick={() => {
              setNotificationOpen(!notificationOpen);
              setSettingsOpen(false);
              setMenuOpen(false);
            }}
          >
            <Bell size={20} />
            {notifications.length - seenNotificationCount > 0 && (
              <span className="notification-badge-premium">
                {notifications.length - seenNotificationCount}
              </span>
            )}
          </button>

          {notificationOpen && (
            <div className="premium-dropdown notification-menu">
              <div className="dropdown-header-premium">
                <h3>Notifications</h3>
                <button
                  className="close-dropdown"
                  onClick={() => {
                    navigate("/notification");
                    setNotificationOpen(false);
                    setSettingsOpen(false);
                    setMenuOpen(false);
                  }}
                >
                  <X size={16} />
                </button>
              </div>
              <div className="dropdown-content-scroll">
                {notifications.length === 0 ? (
                  <div className="empty-state-premium">
                    <div className="empty-icon-box">
                      <Bell size={24} />
                    </div>
                    <p>No new notifications</p>
                    <span>You're all caught up!</span>
                  </div>
                ) : (
                  notifications.map((n, i) => (
                    <div key={i} className="notification-item-premium unread">
                      <div className="notif-icon-premium">
                        <Bell size={16} />
                      </div>
                      <div className="notif-info">
                        <p className="notif-text">
                          {n.type === "CHAT" && `💬 ${n.memberName || ""} - ${n.message || n.title || ""}`}

                          {n.type === "COMPLAINT" && `⚠️ Complaint: ${n.title || n.message || ""}`}
                        </p>
                        <span className="notif-timestamp"> {formatTimeAgo(n.date)}
                        </span>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div className="dropdown-footer-premium">

              </div>
            </div>
          )}
        </div>

        <div className="header-action-item">
          <button
            className={`action-btn-premium ${settingsOpen ? "active" : ""}`}
            onClick={() => {
              setSettingsOpen(!settingsOpen);
              setNotificationOpen(false);
              setMenuOpen(false);
            }}
          >
            <Settings size={20} />
          </button>

          {settingsOpen && (
            <div className="premium-dropdown settings-menu">
              <div className="dropdown-header-premium">
                <h3>Quick Settings</h3>
              </div>
              <div className="dropdown-list">
                <div
                  className="menu-item-premium"
                  onClick={() => navigate("/settings")}
                >
                  <Settings size={18} />
                  <span>General Settings</span>
                </div>
                <div
                  className="menu-item-premium"
                  onClick={() => navigate("/privacy")}
                >
                  <ShieldCheck size={18} />
                  <span>Privacy & Security</span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="header-profile-section">
          <div
            className={`profile-trigger-premium ${menuOpen ? "active" : ""}`}
            onClick={() => {
              setMenuOpen(!menuOpen);
              setNotificationOpen(false);
              setSettingsOpen(false);
            }}
          >
            <div className="avatar-premium">
              <User size={20} />
            </div>
            <div className="user-info-premium d-none d-lg-block">
              <span className="user-name-text">Admin</span>
              <ChevronDown
                size={14}
                className={`chevron-icon ${menuOpen ? "rotate" : ""}`}
              />
            </div>
          </div>

          {menuOpen && (
            <div className="premium-dropdown profile-menu">
              <div className="profile-header-premium">

                <div className="avatar-large-premium">
                  <User size={32} />
                </div>
                <div className="profile-meta">
                  <h4 style={{ color: "#007BFF" }}>Admin User</h4>
                  <p style={{ color: "#007BFF" }}>Administrator</p>
                </div>
              </div>
              <div className="dropdown-divider-premium"></div>
              <div className="dropdown-list">
                <div
                  className="menu-item-premium"
                  onClick={() => navigate("/profile")}
                >
                  <UserCircle size={18} />
                  <span>My Profile</span>
                </div>

                <div className="dropdown-divider-premium"></div>
                <div
                  className="menu-item-premium danger"
                  onClick={handleLogout}
                >
                  <LogOut size={18} />
                  <span>Sign Out</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {showToast && (
        <div className="premium-toast">
          <div className="toast-icon-box">
            <Bell size={18} />
          </div>
          <div className="toast-body">
            <h4>New Notification</h4>
            <p>{toastMessage}</p>
          </div>
          <button className="toast-close" onClick={() => setShowToast(false)}>
            <X size={14} />
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
